import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#D8FFFF"
      d="M104.16 98.73a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path
      fill="#00D8D8"
      d="M23.02 84.08c-.38 0-.77-.15-1.06-.44a1.49 1.49 0 0 1 0-2.12l9.99-9.99a1.49 1.49 0 0 1 2.12 0c.58.59.59 1.54 0 2.12l-9.99 9.99c-.29.29-.68.44-1.06.44"
    />
    <path
      fill="#00D8D8"
      d="M33.02 84.08c-.38 0-.77-.15-1.06-.44l-9.99-9.99a1.49 1.49 0 0 1 0-2.12c.59-.58 1.54-.59 2.12 0l9.99 9.99c.59.59.59 1.54 0 2.12-.29.29-.68.44-1.06.44M94.13 37.46c-.83 0-1.5-.67-1.5-1.5V21.83c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v14.13c0 .83-.67 1.5-1.5 1.5"
    />
    <path
      fill="#00D8D8"
      d="M101.2 30.39H87.07c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h14.13c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5M37.29 107.57c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4"
    />
    <path fill="#0597A3" d="M64.12 68.61h-9.69L37.29 47.87h43.96z" />
    <path
      fill="#00D8D8"
      d="m63.48 83.82-7.11 8c-.68.76-1.94.28-1.94-.74V68.59h9.68v13.54c0 .62-.23 1.22-.64 1.68z"
    />
    <path
      fill="#D8FFFF"
      d="M48.24 28.2a3.78 3.78 0 1 0 0-7.56 3.78 3.78 0 0 0 0 7.56M65.28 21.99a3.78 3.78 0 1 0 0-7.56 3.78 3.78 0 0 0 0 7.56M59.73 34.24a3.78 3.78 0 1 0 0-7.56 3.78 3.78 0 0 0 0 7.56M63.76 101.57a3.78 3.78 0 1 0 0-7.56 3.78 3.78 0 0 0 0 7.56"
    />
    <path
      fill="#00D8D8"
      d="M35.66 40.75h47.23c1.97 0 3.56 1.59 3.56 3.56s-1.59 3.56-3.56 3.56H35.66c-1.97 0-3.56-1.59-3.56-3.56s1.59-3.56 3.56-3.56"
    />
  </svg>
);
const SvgEnrichedIconSalesProcessBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconSalesProcessBrand);
export default Memo;
